var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.formValidate.id === 0 ? "新增退货规则" : "编辑退货规则",
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.cancelVisible,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              staticClass: "formValidate",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "105px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "退货类型:", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: {
                        placeholder: "请选择限购规则",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.formValidate.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formValidate, "type", $$v)
                        },
                        expression: "formValidate.type",
                      },
                    },
                    _vm._l(_vm.returnArr, function (item, index) {
                      return _c("el-option", {
                        key: index.code,
                        attrs: { value: item.code, label: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退货规则名称:", prop: "typeName" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入卡退货规则名称",
                      maxlength: "32",
                      type: "datetime",
                      size: "small",
                      clearable: "",
                    },
                    model: {
                      value: _vm.formValidate.typeName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formValidate,
                          "typeName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formValidate.typeName",
                    },
                  }),
                ],
                1
              ),
              _vm.formValidate.type != 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "开始时间:", prop: "startTime" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "form_content_width",
                        attrs: {
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          size: "small",
                          type: "datetime",
                          placement: "bottom-start",
                          placeholder: "自定义时间",
                        },
                        model: {
                          value: _vm.formValidate.startTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.formValidate, "startTime", $$v)
                          },
                          expression: "formValidate.startTime",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formValidate.type != 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "结束时间:", prop: "endTime" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "form_content_width",
                        attrs: {
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          size: "small",
                          placement: "bottom-end",
                          placeholder: "自定义时间",
                        },
                        model: {
                          value: _vm.formValidate.endTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.formValidate, "endTime", $$v)
                          },
                          expression: "formValidate.endTime",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formValidate.type == 3
                ? _c(
                    "el-form-item",
                    { attrs: { label: "扣费比例:", prop: "factor" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入扣费比例",
                          maxlength: "32",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.formValidate.factor,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formValidate,
                              "factor",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "formValidate.factor",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancelVisible } }, [
                _vm._v("取消"),
              ]),
              _vm.checkPermi(["merchant:product:update"])
                ? _c(
                    "el-button",
                    {
                      staticClass: "submission",
                      attrs: { type: "primary", loading: _vm.loadingBtn },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formValidate")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }